/* inlined via svgr: the wordmark ships inside the JS bundle — no extra
   request, no LCP resource-discovery delay */
import { ReactComponent as Logo } from "../../assets/official/logo.svg";

export default function Header() {
  return (
    <header>
      <a href="#top" className="logo" aria-label="daalab — back to top">
        <Logo width={113} height={24} aria-hidden="true" focusable="false" />
      </a>
      <nav className="top-nav" aria-label="Section navigation">
        <a href="#who-we-are">Team</a>
        <a href="#our-solutions">Solutions</a>
        <a href="#why-to-join">Careers</a>
        <a href="#say-hello">Contact</a>
      </nav>
    </header>
  );
}
